import { render } from "./Wait.vue?vue&type=template&id=6f8c44f8&ts=true"
import script from "./Wait.vue?vue&type=script&lang=ts"
export * from "./Wait.vue?vue&type=script&lang=ts"

import "./Wait.vue?vue&type=style&index=0&id=6f8c44f8&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__